/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Muddy_Away_Tortoise_EndureInputs */

const fr_muddy_away_tortoise_endure = /** @type {(inputs: Muddy_Away_Tortoise_EndureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile - Paiements`)
};

/**

* @param {Muddy_Away_Tortoise_EndureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const muddy_away_tortoise_endure = /** @type {((inputs?: Muddy_Away_Tortoise_EndureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Muddy_Away_Tortoise_EndureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_muddy_away_tortoise_endure(inputs)
});